import { Component, EventEmitter, Input, Output } from '@angular/core';

import { AppliedToplineItem } from 'generated/graphql';

import { ToplineAddClickedEvent } from '../ToplineAddClickedEvent';

@Component({
  selector: 'app-topline-age',
  templateUrl: './topline-age.component.html',
  // styleUrls: ['./topline-address.component.scss']
})
export class ToplineAgeComponent  {
  @Input() topline: Partial<AppliedToplineItem> | any;
  @Input() targetId: string;
  @Input() targetType: 'Entity' | 'EntityConnection';

  /** Will be used for top topline */
  @Input() truncate: boolean;
  @Output() addClick = new EventEmitter<ToplineAddClickedEvent>();

  constructor() { }


  onAddClicked() {
    const eventData = { targetType: this.targetType, targetId: this.targetId, topline: this.topline };
    this.addClick.emit(eventData);
  }
}
